import React from 'react';
import { Phone, Star, Shield, Clock } from 'lucide-react';
import { businessInfo } from '../data/mock';
import { Button } from './ui/button';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center bg-slate-900 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 md:py-40">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-center lg:text-left">
            {/* Trust Badge */}
            <div className="inline-flex items-center gap-2 bg-slate-800/60 backdrop-blur-sm rounded-full px-4 py-2 mb-6 border border-slate-700">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <span className="text-slate-300 text-sm font-medium">{businessInfo.rating} Rating • {businessInfo.reviewCount} Reviews</span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Your Trusted{' '}
              <span className="text-amber-400">Locksmith</span>{' '}
              in South Perth
            </h1>

            <p className="text-xl text-slate-300 mb-8 max-w-xl mx-auto lg:mx-0">
              Fast response, fair pricing, and professional service. DC Lock and Key is here when you need us most.
            </p>

            {/* Feature Pills */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-3 mb-10">
              <div className="flex items-center gap-2 bg-slate-800/60 backdrop-blur-sm rounded-full px-4 py-2 border border-slate-700">
                <Clock className="w-4 h-4 text-amber-400" />
                <span className="text-slate-300 text-sm">Prompt Service</span>
              </div>
              <div className="flex items-center gap-2 bg-slate-800/60 backdrop-blur-sm rounded-full px-4 py-2 border border-slate-700">
                <Shield className="w-4 h-4 text-amber-400" />
                <span className="text-slate-300 text-sm">Trusted Local Expert</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a href={businessInfo.phoneLink}>
                <Button size="lg" className="bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold text-lg px-8 py-6 gap-3 w-full sm:w-auto shadow-lg shadow-amber-500/20 hover:shadow-amber-400/30 transition-all">
                  <Phone className="w-5 h-5" />
                  Call Now
                </Button>
              </a>
              <a href={businessInfo.phoneLink}>
                <Button size="lg" variant="outline" className="border-2 border-slate-600 text-white hover:bg-slate-800 hover:border-slate-500 font-semibold text-lg px-8 py-6 gap-3 w-full sm:w-auto transition-all">
                  <Phone className="w-5 h-5" />
                  Speak to a Locksmith
                </Button>
              </a>
            </div>
          </div>

          {/* Image */}
          <div className="relative hidden lg:block">
            <div className="absolute -inset-4 bg-amber-500/10 rounded-3xl blur-3xl"></div>
            <div className="relative bg-slate-800 rounded-2xl overflow-hidden border border-slate-700 shadow-2xl">
              <img
                src={businessInfo.image}
                alt="DC Lock and Key - Professional Locksmith South Perth"
                className="w-full h-auto object-cover aspect-video"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-slate-900/90 to-transparent p-6">
                <p className="text-white font-bold text-lg">{businessInfo.fullName}</p>
                <p className="text-amber-400">{businessInfo.serviceArea}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block animate-bounce">
        <div className="w-6 h-10 border-2 border-slate-600 rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-amber-400 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
